import { render, staticRenderFns } from "./CodeDetails.vue?vue&type=template&id=37036f5d&scoped=true&"
import script from "./CodeDetails.vue?vue&type=script&lang=ts&"
export * from "./CodeDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CodeDetails.vue?vue&type=style&index=0&id=37036f5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37036f5d",
  null
  
)

export default component.exports